<template>
  <div
    class="z-1 absolute inset-0 flex cursor-wait items-center justify-center bg-white/80"
  >
    <IconEosIconsLoading
      class="text-primary h-10 w-10 animate-spin"
      :class="spinnerClass"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  spinnerClass?: string;
}>();
</script>
